import React, { createContext, useState, useEffect } from "react";
import PropTypes from "prop-types";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null); // Add user state
  const [loading, setLoading] = useState(true); // Global loading state initially true

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");
    if (storedToken) {
      setIsAuthenticated(true);
      setToken(storedToken);
    }
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false); // Ensure loading state is set correctly after checking token
  }, []);

  // Accepts both token and user
  const loginManagement = (newToken, newUser) => {
    // Only store important keys
    const minimalUser = newUser
      ? {
          _id: newUser._id,
          full_name: newUser.full_name,
          permissions: newUser.permissions,
          phone: newUser.phone,
          is_verified: newUser.is_verified,
          is_active: newUser.is_active,
        }
      : null;
    localStorage.setItem("token", newToken);
    setToken(newToken);
    setIsAuthenticated(true);
    if (minimalUser) {
      localStorage.setItem("user", JSON.stringify(minimalUser));
      setUser(minimalUser);
    }
  };

  const logoutManagement = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
  };
  // Method to update loading state
  const setLoadingState = (state) => {
    setLoading(state);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        token,
        user, // Provide user in context
        setUser, // Provide setUser for updates
        loading,
        setLoadingState,
        loginManagement,
        logoutManagement,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { AuthContext, AuthProvider };
